import styled from 'styled-components';

export const StyledStageWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    display: -webkit-box;
    overflow-y: auto;
  }
`;

export const StyledWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  grid-gap: 10px;
`;
